import { isNil } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useUpdateOrderMutation } from '../../apis/mlkApi/mlk.api.hooks';
import { parseRes } from '../../apis/utils';
import { AddressDoorbellPosition } from '../../components/AddressDoorbellPosition/AddressDoorbellPosition';
import { Button } from '../../components/Button/Button';
import Layout, { OrderRequestResult } from '../../components/Layout/Layout';
import { LatLng } from '../../components/Map/Map';
import { useIsEditDoorbellPositionEnabled } from '../../hooks/mlkActions/useIsEditDoorbellPositionEnabled';
import { useBack } from '../../hooks/useBack';
import { useLanguage } from '../../locale/useLanguage';
import { Routes } from '../../routes/types';

import './EditDoorbellPositionView.css';

type EditDoorbellPositionProps = {};

export const EditDoorbellPosition: React.FC<EditDoorbellPositionProps> = () => {
  const [t] = useLanguage();
  const back = useBack();
  const history = useHistory();
  const [{ data: order }, setOrder] = useState<OrderRequestResult>({
    data: undefined,
    isFetching: false,
    isLoading: false,
  });

  const [updateOrder] = useUpdateOrderMutation();
  const isEditDoorbellPositionEnabled = useIsEditDoorbellPositionEnabled();
  const [lat, setLat] = useState<number>();
  const [lng, setLng] = useState<number>();

  useEffect(() => {
    if (
      !isNil(isEditDoorbellPositionEnabled) &&
      !isEditDoorbellPositionEnabled
    ) {
      history.replace(Routes.Home);
    }
  }, [history, isEditDoorbellPositionEnabled]);

  useEffect(() => {
    setLat(
      order?.deliveryAddress.doorbellLatitude || order?.deliveryAddress.lat!
    );
    setLng(
      order?.deliveryAddress.doorbellLongitude || order?.deliveryAddress.lon!
    );
  }, [
    order?.deliveryAddress.doorbellLatitude,
    order?.deliveryAddress.doorbellLongitude,
    order?.deliveryAddress.lat,
    order?.deliveryAddress.lon,
  ]);

  const onMapClick = useCallback(({ lat, lng }: LatLng) => {
    setLat(lat);
    setLng(lng);
  }, []);

  const updateDoorbellPosition = useCallback(() => {
    updateOrder({
      orderId: `${order!.id}`,
      address: {
        doorbellLatitude: lat,
        doorbellLongitude: lng,
      },
    }).then((res) => {
      const { successRes, errorRes } = parseRes(res);
      if (successRes.data) {
        history.push(Routes.Home);
      }
      if (errorRes.error) {
        // TODO: Handle error
      }
    });
  }, [history, lat, lng, order, updateOrder]);

  return (
    <Layout
      hasBack
      onBackClick={back}
      onOrderChange={setOrder}
      title={t('pageTitles.editDoorbellPosition')}
    >
      {order && lat && lng && (
        <div className="edit-doorbell-position--container">
          <AddressDoorbellPosition
            onMapClick={onMapClick}
            lat={lat}
            lng={lng}
            address={order?.deliveryAddress.address}
          />
          <div className="edit-doorbell-position--button-container">
            <Button
              onClick={updateDoorbellPosition}
              label={t('changeAddress.editDoorbellPosition')}
              isPrimary
            />
          </div>
        </div>
      )}
    </Layout>
  );
};
